// Landing page lists and demo content.
export default {
  "Businesses": "الأنشطة",
  "Features": "المزايا",
  "How it works": "كيف يعمل",
  "FAQ": "الأسئلة الشائعة",
  "No setup fees": "بدون رسوم إعداد",
  "Cancel anytime": "إلغاء في أي وقت",
  "business types": "أنواع أنشطة",
  "languages: Arabic & English": "لغتان: العربية والإنجليزية",
  "ways to get paid": "طرق لاستلام المدفوعات",
  "online ordering": "طلب عبر الإنترنت",
  "Table 2": "طاولة 2",
  "Table 4": "طاولة 4",
  "Table 7": "طاولة 7",
  "Online": "أونلاين",
  "2× Tagine, 1× Mint tea": "2× طاجين، 1× شاي بالنعناع",
  "1× Couscous, 2× Salad": "1× كسكس، 2× سلطة",
  "3× Burger, 3× Fries": "3× برغر، 3× بطاطس",
  "Scan to order": "امسح للطلب",
  "Online stores": "المتاجر الإلكترونية",
  "Bookings": "الحجوزات",
  "Restaurants": "المطاعم",
  "Your web address": "عنوان موقعك",
  "Available - this will be your website address.": "متاح - سيكون هذا عنوان موقعك.",
  "This name is not available": "هذا الاسم غير متاح",
  "English letters, numbers and dashes only.": "أحرف إنجليزية وأرقام وشرطات فقط.",
  "Use \"{name}\" instead": "استخدم \"{name}\" بدلًا من ذلك",
  "Choose a web address for your store": "اختر عنوانًا لموقع متجرك",
  "This name is already used by another business. Please choose another one.": "هذا الاسم مستخدم من نشاط آخر. يرجى اختيار اسم آخر.",
  "Use 3-40 English letters, numbers or dashes for your web address.": "استخدم من 3 إلى 40 حرفًا إنجليزيًا أو أرقامًا أو شرطات لعنوان موقعك.",
  "Could not check this name": "تعذر التحقق من هذا الاسم",
  "Logo / profile picture": "الشعار / صورة الملف",
  "Logo uploaded - remember to save": "تم رفع الشعار - لا تنسَ الحفظ",
  "Change logo": "تغيير الشعار",
  "Upload logo": "رفع الشعار",
  "PNG, JPG, WebP or SVG up to 5MB. A square image works best.": "PNG أو JPG أو WebP أو SVG حتى 5 ميغابايت. الصورة المربعة هي الأفضل.",
  "Or paste an image link": "أو الصق رابط صورة",
  "Use an uploaded image or a web link starting with https://": "استخدم صورة مرفوعة أو رابطًا يبدأ بـ https://",
  "CASH": "نقدًا",
  "CARD": "بطاقة",
  "BANK_TRANSFER": "تحويل بنكي",
  "MIXED": "مختلط",
  "DINE_IN": "داخل المطعم",
  "requested": "مطلوب",
  "rejected": "مرفوض",
  "verified": "تم التحقق",
  "LOGIN": "تسجيل دخول",
  "PIN set": "تم تعيين PIN",
  "PIN (4-6 digits)": "PIN (من 4 إلى 6 أرقام)",
  "PIN must be 4 to 6 digits": "يجب أن يتكون PIN من 4 إلى 6 أرقام",
  "Choose a valid role": "اختر دورًا صالحًا",
  "Password must be at least 6 characters": "يجب ألا تقل كلمة المرور عن 6 أحرف",
};
